import React from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@mui/material';
import { canModifyEmployeeByRoleName } from '../../permissions/roleUtils';
import { useRoles } from '../../hooks/useRoles';

function EmployeeRoleCell({ cellValues, onEdit }) {
    const authenticated = useSelector((state) => state.UserReducer.isAuthenticated);
    const { data: allRoles = [] } = useRoles();
    const canModify = canModifyEmployeeByRoleName(authenticated, allRoles, cellValues.row.userRole);

    if (!canModify) {
        return <span>{cellValues.row.userRole}</span>;
    }

    return (
        <Button variant="contained" color="primary" onClick={() => onEdit(cellValues)}>
            {cellValues.row.userRole}
        </Button>
    );
}

export default EmployeeRoleCell;
